<template>
  <div class="game-container">
    <h1>404 - 页面未找到</h1>
    <p>抱歉，您访问的页面不存在。玩一个打砖块游戏吧！</p>
    <div class="info">
      <span>分数: {{ score }}</span> | <span>时间: {{ timeLeft }} 秒</span>
    </div>
    <div class="game-area" ref="gameArea">
      <div class="paddle" :style="{ left: paddleX + 'px' }"></div>
      <div class="ball" :style="{ left: ballX + 'px', top: ballY + 'px' }"></div>
      <div
        v-for="(brick, index) in bricks"
        :key="index"
        class="brick"
        :style="{ left: brick.x + 'px', top: brick.y + 'px' }"
      ></div>
    </div>
    <button v-if="!isPlaying" @click="startGame">开始游戏 / 再玩一次</button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

// 游戏状态
const score = ref(0);
const timeLeft = ref(60);
const paddleX = ref(200);
const ballX = ref(250);
const ballY = ref(250);
const ballSpeedX = ref(2);
const ballSpeedY = ref(-2);
const bricks = ref([]);
const isPlaying = ref(false);
const gameArea = ref(null);
let gameInterval = null;

const paddleWidth = 100;
const ballSize = 20;
const brickWidth = 50;
const brickHeight = 20;
const brickRows = 3;
const brickCols = 8;

// 开始游戏
const startGame = () => {
  score.value = 0;
  timeLeft.value = 60;
  paddleX.value = 200;
  ballX.value = 250;
  ballY.value = 250;
  ballSpeedX.value = 2;
  ballSpeedY.value = -2;
  bricks.value = generateBricks();
  isPlaying.value = true;

  gameInterval = setInterval(updateGame, 16);
};

// 生成砖块
const generateBricks = () => {
  const bricksArray = [];
  for (let row = 0; row < brickRows; row++) {
    for (let col = 0; col < brickCols; col++) {
      bricksArray.push({
        x: col * (brickWidth + 10) + 20,
        y: row * (brickHeight + 10) + 20,
      });
    }
  }
  return bricksArray;
};

// 更新游戏状态
const updateGame = () => {
  if (!isPlaying.value || !gameArea.value) return;

  ballX.value += ballSpeedX.value;
  ballY.value += ballSpeedY.value;

  if (ballX.value <= 0 || ballX.value >= gameArea.value.offsetWidth - ballSize) {
    ballSpeedX.value *= -1;
  }
  if (ballY.value <= 0) {
    ballSpeedY.value *= -1;
  }
  if (ballY.value >= gameArea.value.offsetHeight - ballSize) {
    endGame();
    return;
  }

  if (
    ballY.value + ballSize >= gameArea.value.offsetHeight - 20 &&
    ballX.value >= paddleX.value &&
    ballX.value <= paddleX.value + paddleWidth
  ) {
    ballSpeedY.value *= -1;
  }

  bricks.value.forEach((brick, index) => {
    if (
      ballX.value + ballSize >= brick.x &&
      ballX.value <= brick.x + brickWidth &&
      ballY.value <= brick.y + brickHeight &&
      ballY.value + ballSize >= brick.y
    ) {
      bricks.value.splice(index, 1);
      score.value++;
      ballSpeedY.value *= -1;
    }
  });

  if (bricks.value.length === 0) {
    endGame(true);
    return;
  }

  timeLeft.value -= 0.016;
  if (timeLeft.value <= 0) {
    endGame();
  }
};

// 控制挡板
const movePaddle = (e) => {
  if (!gameArea.value) return;
  const rect = gameArea.value.getBoundingClientRect();
  paddleX.value = e.clientX - rect.left - paddleWidth / 2;
  if (paddleX.value < 0) paddleX.value = 0;
  if (paddleX.value > gameArea.value.offsetWidth - paddleWidth) {
    paddleX.value = gameArea.value.offsetWidth - paddleWidth;
  }
};

// 结束游戏
const endGame = (win = false) => {
  clearInterval(gameInterval);
  isPlaying.value = false;
  alert(win ? `恭喜！分数：${score.value}` : `游戏结束！分数：${score.value}`);
};

// 生命周期管理
onMounted(() => {
  if (gameArea.value) {
    gameArea.value.addEventListener('mousemove', movePaddle);
  }
});

onUnmounted(() => {
  if (gameArea.value) {
    gameArea.value.removeEventListener('mousemove', movePaddle);
  }
  clearInterval(gameInterval);
});
</script>

<style scoped>
.game-container {
  text-align: center;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.game-area {
  position: relative;
  width: 500px;
  height: 400px;
  background-color: #eee;
  margin: 20px auto;
  overflow: hidden;
}

.paddle {
  position: absolute;
  bottom: 10px;
  width: 100px;
  height: 10px;
  background-color: #4caf50;
}

.ball {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #ff6347;
  border-radius: 50%;
}

.brick {
  position: absolute;
  width: 50px;
  height: 20px;
  background-color: #1e90ff;
  border: 1px solid #fff;
}

.info {
  margin: 10px 0;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
